import router from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { Message } from 'element-ui';
import { getToken, getRememberMe } from '@/utils/auth';
import { Route } from 'vue-router';
import { UserModule } from '@/store/modules/user';
import { PermissionModule } from './store/modules/permission';

NProgress.configure({ showSpinner: false });

const whiteList = ['/login', '/forgetPassword'];

// redirectedFrom
router.beforeEach((to: Route, from: Route, next: any) => {
  execultBefore(to, from, next);
});

async function execultBefore(to: Route, from: Route, next: any) {
  NProgress.start();
  if (getToken()) {
    if (to.path === '/login' && getRememberMe() === '1') {
      next({ path: '/' });
      NProgress.done(); // If current page is dashboard will not trigger afterEach hook, so manually handle it
    } else if (to.path === '/login' && getRememberMe() !== '1') {
      next();
      NProgress.done();
    } else if (from.path === '/' && to.redirectedFrom === '/' && getRememberMe() !== '1') {
      next('/login');
      NProgress.done();
    } else if (to.path === '/forgetPassword') {
      next();
      NProgress.done();
    } else {
      if (!UserModule.name || UserModule.name.length === 0) {
        try {
          await UserModule.GetInfo();
          if (!UserModule.email) {
            UserModule.FedLogOut().then(() => {
              Message.error('Verification failed, please login again');
              next({ path: '/' });
              NProgress.done();
            });
          }
          console.log(UserModule.roleInfo.frontPermissions)
          await PermissionModule.GenerateRoutes(UserModule.roleInfo)
          console.log('add:' + JSON.stringify(PermissionModule.addRoutes));
          router.addRoutes(PermissionModule.addRoutes); // 动态添加可访问路由表
          next({ ...to, replace: true }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        } catch (err) {
          UserModule.FedLogOut().then(() => {
            Message.error(err || 'Verification failed, please login again');
            next({ path: '/' });
            NProgress.done();
          });
        }
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login?redirect=${to.path}`); // Redirect to login page
    }
  }
}
router.afterEach(() => {
  NProgress.done();
});
